

import { setToken } from '@/utils/index'
const IS_VIRTUAL_SCHOOL = 1; // 是否是虚拟机构
const loginMixin = {
    methods: {
        dealStuLogin(data) {
            let currentOrgInfo = null;
            let stuList = [];
            if (data.students.length > 1) {
              stuList = data.students.filter(item => {
                return item.is_virtual_school !== IS_VIRTUAL_SCHOOL;
              })
            } else {
              stuList = data.students;
            }
            stuList.forEach((item, index) => {
              if (item.id === data.last_student_id) {
                currentOrgInfo = item;
              }
            })
            if (!currentOrgInfo) {
                currentOrgInfo = stuList[0];
            }
            localStorage.setItem('stuLoginData', JSON.stringify(data))
            localStorage.setItem('studentList', JSON.stringify(stuList))
            localStorage.setItem('stuLoginToken', data.token)
            localStorage.setItem('currentOrgInfo', JSON.stringify(currentOrgInfo));
            setToken(data.token)
            this.$router.push('/stu/choiceOrg')
        }
    }
}

export default loginMixin;